import type { ModuleSpecPage } from './specTypes';

/** F4a : même transformation additive que ModuleSpecProposalNormalizer. */
export function otherPagePatch(page: ModuleSpecPage): Partial<ModuleSpecPage> {
  if (page.kind !== 'other') return {};
  const patch: Partial<ModuleSpecPage> = { kind: 'custom' };
  if (page.reads === undefined) patch.reads = [...new Set((page.entities ?? []).filter(code => !code.startsWith('core:')))];
  if (page.layout === undefined) patch.layout = 'full';
  const refs = /^prototype:([0-9a-f-]{36})\/([0-9a-f-]{36})$/.exec(page.mockupRef ?? '');
  if (page.prototypeRef === undefined && refs) patch.prototypeRef = { importRef: refs[1], pieceRef: refs[2] };
  return patch;
}
